const storageAvailable = (storage) => {
  if (!storage) {
    return false;
  }

  try {
    const testKey = '__agua_storage_test__';
    storage.setItem(testKey, testKey);
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

const createSafeStorage = (getStorage) => {
  let available;

  const getAvailableStorage = () => {
    if (available === false) {
      return null;
    }

    try {
      const storage = getStorage();
      if (available === undefined) {
        available = storageAvailable(storage);
      }
      return available ? storage : null;
    } catch (error) {
      available = false;
      return null;
    }
  };

  return {
    getItem(key) {
      try {
        return getAvailableStorage()?.getItem(key) ?? null;
      } catch (error) {
        return null;
      }
    },

    setItem(key, value) {
      try {
        getAvailableStorage()?.setItem(key, value);
      } catch (error) {
        // El navegador puede bloquear storage. La app debe seguir funcionando.
      }
    },

    removeItem(key) {
      try {
        getAvailableStorage()?.removeItem(key);
      } catch (error) {
        // Ignorado intencionalmente.
      }
    },
  };
};

export const safeLocalStorage = createSafeStorage(() => window.localStorage);
export const safeSessionStorage = createSafeStorage(() => window.sessionStorage);
